import {
    ASSIGN_JOB_TO_USER,
    CREATE_INSPECTION,
    INSPECTION_LIST_BY_DATE,
    UPDATE_INSPECTION_STATUS,
    ADD_ADDITIONAL_NOTES,
    REPORT_MAP_DATA, SET_INSPECTION_ID,
    CLEAR_DATA, RESET_CURRENT_INSPECTION_DETAIL, SELECTED_INSPECTION_DETAIL
} from '../actions/inspection_action';
import {CreateReducer} from '../utils/create_reducer';

const initState = {
    successStatus: false,
    statusMessage: null,
    isFetching: false,
    inspectionDataByDate: [],
    inspectionId:undefined,
    reportData:undefined

};

const inspectionReducer = CreateReducer(initState, {
    [UPDATE_INSPECTION_STATUS](state, action) {
        return {...state, successStatus: action.payload.status, statusMessage: action.payload.statusMessage};
    },
    [ASSIGN_JOB_TO_USER](state, action) {
        return {...state, successStatus: action.payload.success, statusMessage: action.payload.statusMessage};
    },
    [INSPECTION_LIST_BY_DATE](state, action) {
        return {...state, inspectionDataByDate: action.payload, isFetching: false};
    },
    [CREATE_INSPECTION](state, action) {
        return {...state, successStatus: action.payload.success, statusMessage: action.payload.statusMessage,inspectionId:action.payload['inspection_id']};
    },
    [ADD_ADDITIONAL_NOTES](state, action) {
        return {...state, successStatus: action.payload.success, statusMessage: action.payload.statusMessage};
    },
    [REPORT_MAP_DATA](state, action) {
        return {...state,reportData:action.payload };
    },
    [SET_INSPECTION_ID](state,action){
        return {...state,inspectionId:action.inspectionId};
    },
    [SELECTED_INSPECTION_DETAIL](state,action){
        return {...state,selectedInspection: action.payload,isDetailsFetching:false}
    },
    [RESET_CURRENT_INSPECTION_DETAIL](state,action){
        return {...state,selectedInspection: undefined,isDetailsFetching: true}
    },
    [CLEAR_DATA](state,action){
        return {...initState,isFetching:true}
    }
});

export default inspectionReducer;


// WEBPACK FOOTER //
// ./src/reducers/inspection_reducer.js